import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1fc3c0c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CourierCars" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus mr-2" }, null, -1))
const _hoisted_4 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_5 = { class: "flex items-center justify-end mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))
const _hoisted_8 = { class: "mt-6" }
const _hoisted_9 = { class: "flex items-center" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_failed_fetch = _resolveComponent("failed-fetch")!
  const _component_cheap = _resolveComponent("cheap")!
  const _component_the_table = _resolveComponent("the-table")!
  const _component_table_scroll_wrapper = _resolveComponent("table-scroll-wrapper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Автомобили" }),
      (_ctx.havePermissions(['cabinet-courier-car-create', 'all-root-permission']))
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: "/couriers/create-car"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_button, { class: "primary small" }, {
                default: _withCtx(() => [
                  _hoisted_3,
                  _createTextVNode(" Добавить автомобиль ")
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("form", {
      class: "mt-6 mb-6 px-6 py-4 border bg-white",
      onSubmit: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.searchCars && _ctx.searchCars(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_the_select, {
          "can-deselect": "",
          placeholder: "Компания",
          loading: _ctx.data_state.carriers.is_loading,
          failed: _ctx.data_state.carriers.is_failed,
          disabled: _ctx.state.cars.is_loading,
          "error-text": "При получении списка компаний произошла ошибка",
          options: _ctx.data_state.carriers.list,
          value: _ctx.filters_state.companyId,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters_state.companyId) = $event)),
          "infinite-scroll": "",
          "search-without-refresh": "",
          onRefresh: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadCarriers(_ctx.data_state.carriers.pagination.current_page))),
          onLoadmore: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadMoreCarriers(_ctx.data_state.carriers.pagination.current_page + 1))),
          onSearch: _ctx.searchCarriers,
          onOptionBySearch: _ctx.unshiftFindedCarrier
        }, null, 8, ["loading", "failed", "disabled", "options", "value", "onSearch", "onOptionBySearch"]),
        _createVNode(_component_the_select, {
          "can-deselect": "",
          placeholder: "Грузоподъемность",
          value: _ctx.filters_state.ftlCarTypeId,
          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters_state.ftlCarTypeId) = $event)),
          disabled: _ctx.state.cars.is_loading,
          loading: _ctx.data_state.ftl_car_types.is_loading,
          failed: _ctx.data_state.ftl_car_types.is_failed,
          "error-text": "При получении списка грузоподъемностей произошла ошибка",
          options: _ctx.data_state.ftl_car_types.list,
          label: "title",
          "search-by": "title",
          onRefresh: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadFtlCarTypes(_ctx.data_state.ftl_car_types.pagination.current_page)))
        }, null, 8, ["value", "disabled", "loading", "failed", "options"]),
        _createVNode(_component_the_select, {
          "can-deselect": "",
          placeholder: "Статус",
          value: _ctx.filters_state.statusId,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters_state.statusId) = $event)),
          disabled: _ctx.state.cars.is_loading,
          loading: _ctx.data_state.statuses.is_loading,
          failed: _ctx.data_state.statuses.is_failed,
          "error-text": "При получении списка статусов произошла ошибка",
          options: _ctx.data_state.statuses.list,
          label: "name",
          "search-by": "name",
          onRefresh: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadCarStatuses(_ctx.data_state.statuses.pagination.current_page))),
          class: "mt-2"
        }, null, 8, ["value", "disabled", "loading", "failed", "options"]),
        _createVNode(_component_the_input, {
          placeholder: "Гос. номер (например: 849ani02)",
          value: _ctx.filters_state.number,
          "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters_state.number) = $event))
        }, null, 8, ["value"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_the_button, {
          class: "second text small mr-3",
          loading: _ctx.state.cars.is_loading,
          onClick: _ctx.resetFilters
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createTextVNode(" Сбросить ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]),
        _createVNode(_component_the_button, {
          class: "primary text small",
          loading: _ctx.state.cars.is_loading,
          type: "submit"
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _createTextVNode(" Поиск ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32),
    _createElementVNode("div", _hoisted_8, [
      (_ctx.state.cars.is_failed && !_ctx.state.cars.failure.error_state.is_cancel)
        ? (_openBlock(), _createBlock(_component_failed_fetch, {
            key: 0,
            loading: _ctx.state.cars.is_loading,
            text: "При получении списка автомобилей произошла ошибка",
            "error-message": _ctx.state.cars.failure.error_state.message,
            "error-url": _ctx.state.cars.failure.error_state.url,
            "error-status": _ctx.state.cars.failure.error_state.status,
            onRefresh: _cache[9] || (_cache[9] = ($event: any) => (_ctx.loadCars(_ctx.state.cars.pagination.current_page)))
          }, null, 8, ["loading", "error-message", "error-url", "error-status"]))
        : (_openBlock(), _createBlock(_component_table_scroll_wrapper, {
            key: 1,
            loading: _ctx.state.cars.is_loading
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_table, {
                loading: _ctx.state.cars.is_loading,
                columns: _ctx.CouriersCarsColumns,
                rows: _ctx.state.cars.list,
                "with-limit": "",
                "pagination-limit": _ctx.filters_state.limit,
                "pagination-total-items": _ctx.state.cars.pagination.total_items,
                "pagination-current-page": _ctx.state.cars.pagination.current_page,
                "pagination-total-pages": _ctx.state.cars.pagination.total_pages,
                onChangePage: _ctx.loadCars,
                onChangeLimit: _ctx.onLimitChange
              }, {
                td: _withCtx(({ column, row }) => [
                  (column.key === 'company')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (row.company)
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 0,
                              to: `/companies/${row.company.id}`,
                              class: "CourierCars__link"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.cutName(row.company.name, 25)), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" - ")
                            ], 64))
                      ], 64))
                    : (column.key === 'number')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: `/couriers/cars/${row.id}`,
                          class: "CourierCars__link"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.cutName(row[column.key], 10)), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : (column.key === 'model')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createTextVNode(_toDisplayString(_ctx.cutName(row[column.key], 15)), 1)
                          ], 64))
                        : (column.key === 'code_1C')
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              _createTextVNode(_toDisplayString(_ctx.cutName(row[column.key], 25)), 1)
                            ], 64))
                          : (column.key === 'ftl_car_type_name')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                _createTextVNode(_toDisplayString(_ctx.cutName(row[column.key], 10)), 1)
                              ], 64))
                            : (column.key === 'status')
                              ? (_openBlock(), _createBlock(_component_cheap, {
                                  key: 5,
                                  class: _normalizeClass(["small", {
                                    yellow: row[column.key].id === 5,
                                    green: row[column.key].id === 6,
                                    red: row[column.key].id === 7 || row[column.key].id === 8,
                                }])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(row[column.key].name), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["class"]))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                  _createTextVNode(_toDisplayString(row[column.key]), 1)
                                ], 64))
                ]),
                actions: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_9, [
                    (
                                    _ctx.havePermissions([
                                        'cabinet-courier-car-create',
                                        'all-root-permission',
                                    ])
                                )
                      ? (_openBlock(), _createBlock(_component_the_button, {
                          key: 0,
                          class: "extra-small red mr-3",
                          loading: 
                                    _ctx.delete_state.is_loading && _ctx.delete_state.deleting_id === row.id
                                ,
                          onClick: ($event: any) => (_ctx.deleteCar(row.id))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 2
                        }, 1032, ["loading", "onClick"]))
                      : _createCommentVNode("", true),
                    (
                                    _ctx.havePermissions([
                                        'cabinet-courier-car-create',
                                        'all-root-permission',
                                    ])
                                )
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 1,
                          to: `/couriers/cars/${row.id}/update`,
                          class: "mr-3"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_the_button, { class: "extra-small yellow" }, {
                              default: _withCtx(() => [
                                _hoisted_11
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["loading", "columns", "rows", "pagination-limit", "pagination-total-items", "pagination-current-page", "pagination-total-pages", "onChangePage", "onChangeLimit"])
            ]),
            _: 1
          }, 8, ["loading"]))
    ])
  ]))
}